"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiAutocompleteOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        inputRoot: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid " + palette.text.primary,
            },
            '&&[class*="MuiOutlinedInput-root"]': {
                paddingLeft: spacing(2),
                paddingTop: 0,
                paddingBottom: 0,
            },
            '&&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
                paddingTop: spacing(6),
                paddingBottom: spacing(2),
                "&:first-child": {
                    paddingLeft: spacing(2),
                },
                "&:disabled": {
                    opacity: 0.3,
                },
            },
        },
        paper: {
            backgroundColor: palette.background.overlays,
            boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.35);",
        },
        option: {
            color: palette.text.secondary,
            // Paddings have to be overwritten separately because original styles also define them like this.
            // i.e. padding: spacing(2, 4) won't work
            paddingTop: spacing(2),
            paddingBottom: spacing(2),
            paddingLeft: spacing(4),
            paddingRight: spacing(4),
            // Hover
            '&[data-focus="true"]': {
                color: palette.text.primary,
                backgroundColor: palette.action.hover,
            },
            // Selected
            '&[aria-selected="true"]': {
                color: palette.text.primary,
                backgroundColor: palette.action.selected,
            },
        },
    });
};
//# sourceMappingURL=MuiAutocomplete.js.map